import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import { API_BIOMANAGER } from "../../config/config.json";

const prepareHeaders = (includeAuthorization = true) => (headers) => {
    headers.set('content-type', 'application/json');
    headers.set('accept', '*/*');
    headers.set('Accept-Encoding', 'gzip, deflate, br');
    headers.set('Connection', 'keep-alive');

    return headers;
};

const baseQuery = fetchBaseQuery({
    baseUrl: API_BIOMANAGER,
    extraOptions: { timeout: 30000 },
    prepareHeaders: prepareHeaders(true), // Por defecto, se incluye la autorización
});

export const microServiceBioManagerMutation = createApi({
    reducerPath: 'microServiceBioManagerApi',
    baseQuery,
    endpoints: () => ({})
});